export default __webpack_public_path__ + "static/media/diamond-cut-3@3x.ec9b7951.jpg";